'use client';

export const MNTN_ADVERTISER_ID = process.env.NEXT_PUBLIC_MNTN_ADVERTISER_ID;

export const MNTN_CONVERSION_TYPES = {
    signUp: 'SignUp'
} as const;

const injectPixel = ( query: string ) => {
    if ( !MNTN_ADVERTISER_ID || typeof window === 'undefined' ) {
        return;
    }

    try {
        const referrer = encodeURIComponent( ( document.referrer ?? '' ).substring( 0, 2048 ) );
        const pageUrl = encodeURIComponent( window.location.href.substring( 0, 2048 ) );
        const cacheBuster = Math.floor( Math.random() * 1e17 );
        const script = document.createElement( 'script' );

        script.type = 'text/javascript';
        script.async = true;
        script.src = `https://dx.mountain.com/spx?${ query }shaid=${ MNTN_ADVERTISER_ID }&tdr=${ referrer }&plh=${ pageUrl }&cb=${ cacheBuster }`;
        document.head.appendChild( script );
    } catch ( e ) {
        if ( e && e instanceof Error ) {
            console.error( `Error firing MNTN pixel - ${ e.message }` );
        }
    }
};

export const pageview = () => {
    injectPixel( '' );
};

export const signupConversion = () => {
    if ( !MNTN_ADVERTISER_ID || typeof window === 'undefined' ) {
        return;
    }

    try {
        /* eslint-disable */
        ( function () { var x = null, p: any, q, m: any,
            o = MNTN_ADVERTISER_ID,
            conversion_type = MNTN_CONVERSION_TYPES.signUp,
            order_id = "",
            order_amt = "",
            b = "", c = "", k = "", g = "", j = "", u = ""; try { p = ( top as any ).document.referer !== "" ? encodeURIComponent( ( top as any ).document.referrer.substring( 0, 2048 ) ) : "" } catch ( n ) { p = document.referrer !== null ? document.referrer.toString().substring( 0, 2048 ) : "" } try { m = parent.location.href !== "" ? encodeURIComponent( parent.location.href.toString().substring( 0, 2048 ) ) : "" } catch ( z ) { try { m !== null ? encodeURIComponent( ( window as any ).i.toString().substring( 0, 2048 ) ) : "" } catch ( h ) { m = "" } }
        var A: any, y = document.createElement( "script" ), w = null as string | null, v = document.getElementsByTagName( "script" ), t = Number( v.length ) - 1, r = document.getElementsByTagName( "script" )[ t ]; if ( typeof A === "undefined" ) { A = Math.floor( Math.random() * 1e17 ) }
        w = "https://dx.mountain.com/spx?conv=1" + "&shaid=" + o + "&tdr=" + p + "&plh=" + m + "&cb=" + A + "&shoid=" + order_id + "&shoamt=" + order_amt + "&type=" + conversion_type + "&shocur=" + c + "&shopid=" + k + "&shoq=" + g + "&shoup=" + j + "&shpil=" + u + b; y.type = "text/javascript"; y.src = w; r.parentNode!.insertBefore( y, r ) }() );
        /* eslint-enable */
    } catch ( e ) {
        if ( e && e instanceof Error ) {
            console.error( `Error firing MNTN conversion - ${ e.message }` );
        }
    }
};
